import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./mobilenav.scss";
import Logo from "../../assets/img/logo.png";
import TopBar from "./topbar";
import NavBar from "./navbar";

const MobileNav = () => {
  useEffect(() => {
    const OpenCloseBTN = document.getElementById("MenuIcons");
    const CloseBtn = document.getElementById("CloseBTNS");
    const MobileNavSHow = document.querySelectorAll(".MobileNavContainer");

    MobileNavSHow.forEach((eL) => {
      OpenCloseBTN.addEventListener("click", () => {
        document.body.style.overflow = "hidden";
        eL.classList.add("active");
      });
      CloseBtn.addEventListener("click", () => {
        eL.classList.remove("active");
        document.body.style.overflow = "auto";
      });
    });
    return () => {
      OpenCloseBTN.removeEventListener("click", () => {});
      CloseBtn.removeEventListener("click", () => {});
    };
  }, []);

  return (
    <>
      <div className="HambergerMenuBox" id="MenuIcons">
        <MenuIcon fontSize="large" />
      </div>
      <div className="MobileNavContainer">
        <div className="MobileNavItemBox">
          <div className="CloseBTN" id="CloseBTNS">
            <CloseIcon fontSize="large" />
          </div>
          <div className="MobileViewLogo">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="MobileNavBox">
            <NavBar
              closeMobileNav={() => {
                document.body.style.overflow = "auto";
                document
                  .querySelector(".MobileNavContainer")
                  .classList.remove("active");
              }}
            />
            <TopBar
              closeMobileNav={() => {
                document.body.style.overflow = "auto";
                document
                  .querySelector(".MobileNavContainer")
                  .classList.remove("active");
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
